
/* SOW Nutrition 2026 · generated by site-sownutrition/tema/gerar_tema.py */
(function(){
  var loja = document.getElementById('loja');
  if (!loja) return;
  var bm = document.getElementById('b-menu');
  if (bm) bm.addEventListener('click', function(){
    var aberto = loja.classList.toggle('menu-aberto');
    bm.setAttribute('aria-expanded', aberto ? 'true' : 'false');
  });

  // home banners: they rotate; the dots switch them
  var slides = Array.prototype.slice.call(loja.querySelectorAll('.banner .slide')),
      dots = Array.prototype.slice.call(loja.querySelectorAll('.pontos button')), atual = 0, t;
  function mostra(i){
    atual = i;
    slides.forEach(function(s, k){ s.classList.toggle('on', k === i); });
    dots.forEach(function(d, k){ d.classList.toggle('on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
  }
  dots.forEach(function(d, k){ d.addEventListener('click', function(){ clearInterval(t); mostra(k); }); });
  if (slides.length > 1 && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    t = setInterval(function(){ mostra((atual + 1) % slides.length); }, 6000);
  }

  // collection sorting: Shopify sorts on the server
  var ord = loja.querySelector('[data-ordenar]');
  if (ord) ord.addEventListener('change', function(){
    var u = new URL(location.href); u.searchParams.set('sort_by', ord.value); u.searchParams.delete('page'); location.href = u.toString();
  });

  // quantity buttons (product page and cart)
  Array.prototype.forEach.call(loja.querySelectorAll('.qtd'), function(q){
    var inp = q.querySelector('[data-qtd-input]'); if (!inp) return;
    var minimo = inp.hasAttribute('data-envia') ? 0 : 1;
    function muda(d){
      inp.value = Math.max(minimo, Math.min(99, (parseInt(inp.value, 10) || minimo) + d));
      if (inp.hasAttribute('data-envia')) { var f = inp.form, b = f && f.querySelector('[name="update"]'); if (b) b.click(); }
    }
    if (inp.hasAttribute('data-envia')) {
      var atualiza = function(){ var b = inp.form && inp.form.querySelector('[name="update"]'); if (b) b.click(); };
      inp.addEventListener('change', atualiza);
      inp.addEventListener('keydown', function(e){ if (e.key === 'Enter') { e.preventDefault(); atualiza(); } });
    }
    var menos = q.querySelector('[data-menos]'), mais = q.querySelector('[data-mais]');
    if (menos) menos.addEventListener('click', function(){ muda(-1); });
    if (mais) mais.addEventListener('click', function(){ muda(1); });
  });

  // product gallery
  var g = loja.querySelector('[data-galeria]');
  if (g) {
    var imgs = g.querySelectorAll('.g-img'), bts = g.querySelectorAll('.g-mini button');
    Array.prototype.forEach.call(bts, function(b, i){
      b.addEventListener('click', function(){
        Array.prototype.forEach.call(imgs, function(im, k){ im.classList.toggle('on', k === i); });
        Array.prototype.forEach.call(bts, function(x, k){ x.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      });
    });
  }

  // buy bar: appears once the buy button scrolls out of view
  var barra = loja.querySelector('[data-barra]'), alvo = loja.querySelector('.acoes-compra');
  if (barra && alvo && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(es){
      var e = es[0], passou = !e.isIntersecting && e.boundingClientRect.top < 0;
      barra.classList.toggle('visivel', passou);
      barra.setAttribute('aria-hidden', passou ? 'false' : 'true');
      var b = barra.querySelector('button'); if (b) b.tabIndex = passou ? 0 : -1;
    }).observe(alvo);
  }
})();

(function(){
  var caixa = document.querySelector('[data-aval]');
  if (!caixa || !window.fetch || !window.DOMParser) return;
  var mais = document.querySelector('[data-aval-mais]'), pagina = 0, POR = 6;
  var MESES = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
  function txt(r, q){ var e = r.querySelector(q); return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function el(tag, cls, t){ var e = document.createElement(tag); if (cls) e.className = cls; if (t) e.textContent = t; return e; }
  function nome(t){ var p = t.split(' ').filter(Boolean); return p.length > 1 ? p[0] + ' ' + p[p.length - 1].charAt(0).toUpperCase() + '.' : (p[0] || 'Cliente'); }
  function carrega(){
    pagina++;
    mais.disabled = true;
    var l = encodeURIComponent(caixa.dataset.loja);
    fetch('https://api.judge.me/reviews/reviews_for_widget?url=' + l + '&shop_domain=' + l + '&platform=shopify&page=' + pagina +
          '&per_page=' + POR + '&product_id=' + encodeURIComponent(caixa.dataset.produto))
      .then(function(r){ if (!r.ok) throw r; return r.json(); })
      .then(function(d){
        var doc = new DOMParser().parseFromString(d.html || '', 'text/html');
        Array.prototype.forEach.call(doc.querySelectorAll('.jdgm-rev'), function(r){
          var corpo = txt(r, '.jdgm-rev__body');
          if (!corpo) return;
          var nota = parseInt((r.querySelector('.jdgm-rev__rating') || {getAttribute: function(){ return '5'; }}).getAttribute('data-score'), 10) || 5;
          var a = el('article', 'aval');
          var est = el('span', 'aval-est', '★★★★★'.slice(0, nota) + '☆☆☆☆☆'.slice(0, 5 - nota));
          est.setAttribute('role', 'img'); est.setAttribute('aria-label', nota + ' de 5 estrelas');
          a.appendChild(est);
          var t = txt(r, '.jdgm-rev__title');
          if (t && corpo.indexOf(t) !== 0) a.appendChild(el('h3', '', t));
          a.appendChild(el('p', '', corpo));
          var info = nome(txt(r, '.jdgm-rev__author'));
          if (r.getAttribute('data-verified-buyer') === 'true') info += ' · Compra verificada';
          var tm = r.querySelector('.jdgm-rev__timestamp'), dt = tm && new Date(tm.getAttribute('datetime'));
          if (dt && !isNaN(dt)) info += ' · ' + MESES[dt.getMonth()] + ' de ' + dt.getFullYear();
          a.appendChild(el('small', '', info));
          caixa.appendChild(a);
        });
        caixa.hidden = !caixa.children.length;
        mais.hidden = pagina * POR >= (d.total_count || 0);
        mais.disabled = false;
      })
      .catch(function(){ mais.hidden = true; });
  }
  mais.addEventListener('click', carrega);
  carrega();
})();

(function(){
  var raiz = document.getElementById('shopify-section-carrinho-lateral');
  if (!raiz || !window.fetch || !window.DOMParser) return;
  var url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var aberta = false, antes = null, ultimo = null;
  function gaveta(){ return raiz.querySelector('[data-gaveta]'); }
  function aplica(){
    var g = gaveta(), f = raiz.querySelector('[data-gaveta-fundo]');
    if (!g) return;
    g.classList.toggle('aberta', aberta);
    g.setAttribute('aria-hidden', aberta ? 'false' : 'true');
    if (f) f.hidden = !aberta;
    document.documentElement.classList.toggle('gaveta-aberta', aberta);
    Array.prototype.forEach.call(document.querySelectorAll('.sacola'), function(s){
      var i = s.querySelector('i'), t = s.querySelector('.total');
      if (i) i.textContent = g.getAttribute('data-gv-itens');
      if (t) t.textContent = g.getAttribute('data-gv-total');
    });
  }
  function abre(){
    if (!aberta) antes = document.activeElement;
    aberta = true; aplica();
    var g = gaveta(); if (g) g.focus();
  }
  function fecha(){
    aberta = false; aplica();
    if (antes && antes.focus) antes.focus();
  }
  function renderiza(){
    return fetch(url + '?sections=carrinho-lateral', {credentials: 'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(d){
        var doc = new DOMParser().parseFromString(d['carrinho-lateral'] || '', 'text/html');
        var novo = doc.getElementById('shopify-section-carrinho-lateral');
        if (novo) raiz.innerHTML = novo.innerHTML;
        aplica();
      });
  }
  function erro(msg){
    var e = raiz.querySelector('[data-gv-erro]');
    if (e) { e.textContent = msg || ''; e.hidden = !msg; }
  }
  function ocupado(b, sim){
    if (!b) return;
    if (sim) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    if ('disabled' in b && b.tagName === 'BUTTON') b.disabled = sim;
  }
  function adiciona(corpo, botao, reserva){
    ocupado(botao, true);
    var form = corpo instanceof FormData;
    fetch(url + 'cart/add.js', {method: 'POST', credentials: 'same-origin',
      headers: form ? {'Accept': 'application/json'} : {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: form ? corpo : JSON.stringify(corpo)})
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(){ return renderiza().then(function(){ erro(''); abre(); }); },
            function(j){ return renderiza().then(function(){ erro((j && j.description) || 'Não foi possível adicionar agora. Tente de novo.'); abre(); }); })
      .catch(function(){ if (reserva) reserva(); })
      .then(function(){ ocupado(botao, false); });
  }

  // the last submit button clicked (Safari before 15.4 has no event.submitter)
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('button[type="submit"]');
    if (b) ultimo = b;
  }, true);

  document.addEventListener('click', function(e){
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var t = e.target.closest ? e.target : e.target.parentElement;
    var a = t.closest('a.comprar[href*="/cart/add"]');
    if (a) {
      var u = new URL(a.href, location.href), id = parseInt(u.searchParams.get('id'), 10);
      if (id) {
        e.preventDefault();
        adiciona({items: [{id: id, quantity: parseInt(u.searchParams.get('quantity'), 10) || 1}]}, a, function(){ location.href = a.href; });
      }
      return;
    }
    if (t.closest('.sacola') && !document.body.classList.contains('modelo-cart')) {
      e.preventDefault(); abre(); renderiza(); return;
    }
    if (t.closest('[data-gaveta-fechar]') || t.matches('[data-gaveta-fundo]')) { fecha(); return; }
    var b = t.closest('[data-gv-linha]');
    if (b) {
      b.disabled = true;
      fetch(url + 'cart/change.js', {method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({line: parseInt(b.getAttribute('data-gv-linha'), 10), quantity: parseInt(b.getAttribute('data-gv-qtd'), 10)})})
        .then(renderiza)
        .then(function(){ var g = gaveta(); if (g) g.focus(); })
        .catch(function(){ location.href = url + 'cart'; });
    }
  });

  document.addEventListener('submit', function(e){
    var f = e.target;
    if (e.defaultPrevented || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var sub = e.submitter || ultimo;
    if (sub && sub.name === 'return_to') return;              // "Comprar agora": straight to checkout
    e.preventDefault();
    var fd = new FormData(f);
    adiciona(fd, sub || f.querySelector('[type="submit"]'), function(){ f.submit(); });
  });

  document.addEventListener('keydown', function(e){
    if (!aberta) return;
    if (e.key === 'Escape') { fecha(); return; }
    if (e.key !== 'Tab') return;
    var g = gaveta(), focos = g ? g.querySelectorAll('a[href],button:not([disabled])') : [];
    if (!focos.length) return;
    var p = focos[0], u = focos[focos.length - 1];
    if (e.shiftKey && (document.activeElement === p || document.activeElement === g)) { e.preventDefault(); u.focus(); }
    else if (!e.shiftKey && document.activeElement === u) { e.preventDefault(); p.focus(); }
  });
})();
